import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import usersService from "../../../services/users.service";

type UserSlice = {
  users: any;
  loading: boolean;
  error: any | unknown;
  count: number;
  allUserWithTasks: [];
  selectedUser: any;
};
// Initialize

const initialState: UserSlice = {
  users: [],
  loading: false,
  count: 0,
  error: null,
  allUserWithTasks: [],
  selectedUser: null,
};

// Get all users

export const getUsers = createAsyncThunk(
  "users/getUsers",
  async ({ page, limit }: any, { rejectWithValue }) => {
    try {
      const response = await usersService.fetchAll(page, limit);
      return response.data?.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error);
    }
  }
);
export const getUsersCount = createAsyncThunk(
  "users/getUsersCount",
  async ({ page, limit }: any, { rejectWithValue }) => {
    try {
      const response = await usersService.fetchAll();
      return response.data?.length;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error);
    }
  }
);

export const approveUser = createAsyncThunk(
  "users/approveUser",
  async (id, { rejectWithValue }) => {
    try {
      await usersService.isActive(id);
      const response = await usersService.fetchAll();
      return response.data?.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error);
    }
  }
);

// Update User

export const updateUser = createAsyncThunk(
  "users/updateUser",
  async (
    {
      id,
      username,
      email,
      phone,
      password,
      initial_balance,
      level,
    }: {
      id: string;
      username: string;
      email: string;
      phone: string;
      password: string;
      initial_balance: number;
      level: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const data = { username, email, phone, password, initial_balance, level };
      const res = await usersService.update(id, data);
      if (res) {
        const response = await usersService.fetchAll();
        return response.data?.data;
      }
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
// delete users
export const SelectSingleUser = createAsyncThunk(
  "users/selectUser",
  async ({ id }: { id: string }, { rejectWithValue }) => {
    try {
      const response = await usersService.fetchById(id);
      return response.data?.data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
export const changeUserBalance = createAsyncThunk(
  "users/userbalance",
  async ({ id, data }: { id: string; data: any }, { rejectWithValue }) => {
    try {
      const res = await usersService.changeUserBalance(id, data);
      if (res) {
        const response = await usersService.fetchAll();
        return response.data?.data;
      }
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
export const deleteUser = createAsyncThunk(
  "users/deleteUser",
  async (id, { rejectWithValue }) => {
    try {
      await usersService.deleteUser(id);
      const response = await usersService.fetchAll();
      return response.data?.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

// get user with tasksk
export const getUserWithTaks = createAsyncThunk(
  "/users/getUserWithTasks",
  async (_, { rejectWithValue }) => {
    try {
      const response = await usersService.getUserWithTasks();
      return response.data?.data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error);
    }
  }
);

// Create slice

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload;
        state.error = null;
      })
      .addCase(getUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getUsersCount.fulfilled, (state, action: any) => {
        state.loading = false;
        state.count = action.payload;
      })
      .addCase(getUsersCount.rejected, (state, action: any) => {
        state.loading = false;
      })
      .addCase(getUsersCount.pending, (state, action: any) => {
        state.loading = true;
      })
      // Approve user
      .addCase(approveUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(approveUser.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload;
        state.error = null;
      })
      .addCase(approveUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // delete user
      .addCase(deleteUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        const index = state.users.findIndex(
          ({ id }: { id: string }) => id === action.payload.id
        );
        state.users.splice(index, 1);
      })
      .addCase(deleteUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // updating
      .addCase(updateUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateUser.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // get users with tasksk
      .addCase(getUserWithTaks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserWithTaks.fulfilled, (state, action) => {
        state.loading = false;
        state.allUserWithTasks = action.payload;
        state.error = null;
      })
      .addCase(getUserWithTaks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(SelectSingleUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(SelectSingleUser.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedUser = action.payload;
        state.error = null;
      })
      .addCase(SelectSingleUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(changeUserBalance.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(changeUserBalance.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload;
        state.error = null;
      })
      .addCase(changeUserBalance.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Selectors

export const selectUsers = (state: any) => state?.users.users;
export const selectCAllUserWithTasks = (state: any) =>
  state.users.allUserWithTasks;
export const selectLoading = (state: any) => state.users.loading;
export const selectError = (state: any) => state.users.error;
export const selectUser = (state: any) => state.users.selectedUser;
export const selectCount = (state: any) => state.users.count;

// Export reducer

export default usersSlice.reducer;
